import { render } from "./CustomerPricingForm.vue?vue&type=template&id=08ce9141&scoped=true"
import script from "./CustomerPricingForm.vue?vue&type=script&lang=js"
export * from "./CustomerPricingForm.vue?vue&type=script&lang=js"

import "./CustomerPricingForm.vue?vue&type=style&index=0&id=08ce9141&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ce9141"]])

export default __exports__